module.exports = __webpack_public_path__ + "img/logintop.cf9a7210.png";